import { render, staticRenderFns } from "./PayrollDetailComponent.vue?vue&type=template&id=7a46c0ae"
import script from "./PayrollDetailComponent.vue?vue&type=script&lang=js"
export * from "./PayrollDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports